declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

/**
 * Lê variáveis REACT_APP_* injetadas em runtime (window._env_, gerado pelo
 * entrypoint do nginx via envsubst) com fallback pro valor de build-time
 * (process.env), pra manter compatibilidade quando _env_ não existir.
 */
export function getEnv(key: string): string | undefined {
  return window._env_?.[key] ?? process.env[key];
}
